import { compose, equals, prop, toLower } from 'ramda';
import getUrlParamsToLower from './getUrlParamsToLower';
/**
 * Check if a query parameter in the current URL has a specific value
 * @param {String} key
 * @param {String} value
 * @returns {Boolean}
 */
/* getting browser query and creating lowercased object from it,
using lowerrcased inserted key on that object and see if value is matching inserted value.
 */
const isUrlParamEquals = (key, value) => compose(equals(value), compose(prop, toLower)(key))(getUrlParamsToLower());
export default isUrlParamEquals;
//# sourceMappingURL=isUrlParamEquals.js.map